const Educationdata
=[
    {
        id : "1",
        schemeName: "Swadesh Darshan Scheme",
        discription:"To develop theme-based tourist circuits in the country.These tourist circuits will be developed on the principles of high tourist value, competitiveness and sustainability in an integrated manner.",
        launchDate: "2014-2015",
        AnualFund: "12745"

    },
   {id : "2",
    schemeName: "Pilgrimage Rejuvention and Spiritual Augmentation Drive (PRASAD)",
    discription:"The Pilgrimage Rejuvenation and Spiritual Augmentation Drive (PRASAD) is a government scheme that focuses on identifying and developing the pilgrim sites across the country to enrich the religious tourism experience.",
    launchDate: "2014-2015",
    AnualFund: "123475"},
   

    {id : "3",
    schemeName: "Adopt a Heritage Project",
    discription:"This project is a key initiative of Ministry of Tourism in close collaboration with Ministry of Culture and Archeological Survey of India (ASI), to develop the heritage sites / monuments and making them tourist-friendly to enhance the tourism potential and their cultural importance in a planned and phased manner",
    launchDate: "27 September 2017",
    AnualFund: "12375"},

]
export default Educationdata;